import { render, staticRenderFns } from "./country-selector.vue?vue&type=template&id=a516b790"
import script from "./country-selector.vue?vue&type=script&lang=js"
export * from "./country-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports